import { QualityControl } from './quality-control'

export { QualityControl }